export default "__VITE_ASSET__L3O$bAkP__"